import React from "react";
import { Link } from "react-router-dom";
import LogoFull from "./LogoFull";
import { ArrowSquareOut, House } from "@phosphor-icons/react";

/**
 * HelpLayout — Doku-Site-Layout für die /hilfe-Route.
 *
 * Iter 19.63.108 — User-Wunsch: eigene Doku-Seite im Stil moderner
 * Produkt-Dokumentationen (Stripe-Docs / Linear-Docs). Bewusst OHNE
 * das normale `UserLayout`, damit die Hilfe wie ein eigenständiges
 * Mini-Produkt wirkt und auch ohne Login-Kontext lesbar bleibt
 * (kein Sidebar, keine „Neue Einstufung"-Toolbar, kein ChatBubble).
 *
 * Children erhalten die volle Breite und entscheiden selbst über ihr
 * inneres 2-Spalten-Layout (TOC + Content).
 */
export default function HelpLayout({ children }) {
  return (
    <div className="min-h-screen bg-warm-50/40">
      {/* Top-Bar — Logo + Zurück-zur-App-Link. Sticky, schmal, ruhig. */}
      <header
        className="sticky top-0 z-30 border-b border-ink-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80"
        data-testid="help-topbar"
      >
        <div className="mx-auto max-w-7xl px-6 lg:px-10 h-14 flex items-center justify-between gap-4">
          <Link
            to="/"
            className="inline-flex items-center transition-crisp hover:opacity-80"
            data-testid="help-logo"
            title="Zur Startseite"
          >
            <LogoFull size="sm" />
            <span className="ml-3 hidden sm:inline-flex items-center gap-1.5 rounded-sm border border-ink-200 bg-ink-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-warm-700">
              Dokumentation
            </span>
          </Link>
          <div className="flex items-center gap-2">
            <Link
              to="/dashboard"
              className="inline-flex items-center gap-1.5 rounded-sm border border-ink-300 bg-white px-3 py-1.5 text-xs font-medium text-ink-700 transition-crisp hover:bg-ink-100"
              data-testid="help-back-to-app"
              title="Zurück zur Einstufung"
            >
              <House size={13} weight="bold" />
              <span className="hidden sm:inline">Zurück zur App</span>
              <ArrowSquareOut size={11} weight="bold" className="opacity-60" />
            </Link>
          </div>
        </div>
      </header>

      {/* Page content */}
      <main data-testid="help-main">{children}</main>

      {/* Print-friendly footer */}
      <footer
        className="border-t border-ink-200 bg-white py-6 print:hidden"
        data-testid="help-footer"
      >
        <div className="mx-auto max-w-7xl px-6 lg:px-10 flex flex-wrap items-center justify-between gap-3 text-[11px] text-warm-500">
          <span>
            ET · Dokumentation für Sachbearbeiter:innen ·{" "}
            <Link to="/impressum" className="underline-offset-2 hover:underline">
              Impressum
            </Link>
          </span>
          <span>
            Letzte inhaltliche Aktualisierung: Juni 2026
          </span>
        </div>
      </footer>
    </div>
  );
}
